// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    margin: 0;
    border-bottom: thin solid var(--header-border-color);
    background-color: var(--header-background-color);
    color: var(--header-text-color);
    box-shadow: 0px 0px 6px -3px rgba(0,0,0,0.25);
    z-index: 10;
}

header .grid {
    box-sizing: border-box;
    display: grid;
}
header #navigation {
    display: flex;
    align-items: center;
    justify-content: right;

    font-size: 18px;
}

header #primary.navigation-block {
    margin-left: 7px;
}

header .navigation-block a.nav-link:link, 
header .navigation-block a.nav-link:active, 
header .navigation-block a.nav-link:visited,
header .navigation-block a.nav-link:hover {
    padding: 5px;
    margin: 0 5px;
}
header .floating-menu .menu-item:hover {
    color: white;
    background-color: var(--header-menu-background-highlight-color);
}
header .floating-menu .menu-item a:hover {
    color: white;
}

header a:link, header a:active, header a:visited {
    color: var(--header-text-color);
}

header a:hover {
    color: var(--header-text-highlight-color);
}
header svg {
    display: inline-block;
    width: 18px;
    height: 18px;
    margin-right: 6px;
    margin-bottom: -2px;
}
header .mobile-menu-trigger {
    text-align: center;
}
header .mobile-menu-trigger svg {
    width: 24px;
    height: 24px;
    margin-bottom: -3px
}

header .mobile-menu {
    text-align: center;
}

header #navigation .outline {
    display: inline-block;
}
header #navigation .active .outline {
    display: none;
}
header #navigation .solid {
    display: none;
}
header #navigation .active .solid {
    display: inline-block;
}

@media (1220px < width) {
    header .grid {
        grid-template-columns: 200px auto;
        padding: 0 25px;
    }
}
@media (width <= 1220px) {
    header .grid {
        grid-template-columns: 32px auto;
        padding: 0 0 0 15px;
    }
    header #navigation .navigation-block a.nav-link {
        display: inline-block;
        text-align: center;
    }
    header .nav-text {
        display: block;
        font-size: 10px;
        line-height: 6px;
    }
    header .communities-logo .logo-text {
        display: none;
    }
}

`, "",{"version":3,"sources":["webpack://./client/components/header/Header.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,oDAAoD;IACpD,gDAAgD;IAChD,+BAA+B;IAC/B,6CAA6C;IAC7C,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;;IAEtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;IAII,YAAY;IACZ,aAAa;AACjB;AACA;IACI,YAAY;IACZ,+DAA+D;AACnE;AACA;IACI,YAAY;AAChB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;AAC7C;AACA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,iCAAiC;QACjC,eAAe;IACnB;AACJ;AACA;IACI;QACI,gCAAgC;QAChC,mBAAmB;IACvB;IACA;QACI,qBAAqB;QACrB,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":["header {\n    box-sizing: border-box;\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    margin: 0;\n    border-bottom: thin solid var(--header-border-color);\n    background-color: var(--header-background-color);\n    color: var(--header-text-color);\n    box-shadow: 0px 0px 6px -3px rgba(0,0,0,0.25);\n    z-index: 10;\n}\n\nheader .grid {\n    box-sizing: border-box;\n    display: grid;\n}\nheader #navigation {\n    display: flex;\n    align-items: center;\n    justify-content: right;\n\n    font-size: 18px;\n}\n\nheader #primary.navigation-block {\n    margin-left: 7px;\n}\n\nheader .navigation-block a.nav-link:link, \nheader .navigation-block a.nav-link:active, \nheader .navigation-block a.nav-link:visited,\nheader .navigation-block a.nav-link:hover {\n    padding: 5px;\n    margin: 0 5px;\n}\nheader .floating-menu .menu-item:hover {\n    color: white;\n    background-color: var(--header-menu-background-highlight-color);\n}\nheader .floating-menu .menu-item a:hover {\n    color: white;\n}\n\nheader a:link, header a:active, header a:visited {\n    color: var(--header-text-color);\n}\n\nheader a:hover {\n    color: var(--header-text-highlight-color);\n}\nheader svg {\n    display: inline-block;\n    width: 18px;\n    height: 18px;\n    margin-right: 6px;\n    margin-bottom: -2px;\n}\nheader .mobile-menu-trigger {\n    text-align: center;\n}\nheader .mobile-menu-trigger svg {\n    width: 24px;\n    height: 24px;\n    margin-bottom: -3px\n}\n\nheader .mobile-menu {\n    text-align: center;\n}\n\nheader #navigation .outline {\n    display: inline-block;\n}\nheader #navigation .active .outline {\n    display: none;\n}\nheader #navigation .solid {\n    display: none;\n}\nheader #navigation .active .solid {\n    display: inline-block;\n}\n\n@media (1220px < width) {\n    header .grid {\n        grid-template-columns: 200px auto;\n        padding: 0 25px;\n    }\n}\n@media (width <= 1220px) {\n    header .grid {\n        grid-template-columns: 32px auto;\n        padding: 0 0 0 15px;\n    }\n    header #navigation .navigation-block a.nav-link {\n        display: inline-block;\n        text-align: center;\n    }\n    header .nav-text {\n        display: block;\n        font-size: 10px;\n        line-height: 6px;\n    }\n    header .communities-logo .logo-text {\n        display: none;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
